var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".info_svg__st0{stroke-linecap:round;stroke-linejoin:round}.info_svg__st0,.info_svg__st1{fill:none;stroke:currentColor;stroke-width:1.5}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info_svg__Group_1715"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "info_svg__Ellipse_282",
    className: "info_svg__st0",
    cx: 12,
    cy: 12,
    r: 11.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "info_svg__Path_5133",
    className: "info_svg__st0",
    d: "M10.2 10.2H12v7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "info_svg__Line_647",
    className: "info_svg__st0",
    d: "M10.2 17.5h3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "info_svg__Path_5134",
    className: "info_svg__st1",
    d: "M12 6.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "info_svg__Path_5135",
    className: "info_svg__st1",
    d: "M12 6.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5"
  }))));
}
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI1LjQuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiCgkgdmlld0JveD0iMCAwIDI0IDI0IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTpjdXJyZW50Q29sb3I7c3Ryb2tlLXdpZHRoOjEuNTtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7fQoJLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOmN1cnJlbnRDb2xvcjtzdHJva2Utd2lkdGg6MS41O30KPC9zdHlsZT4KPGcgaWQ9Ikdyb3VwXzE3MTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiPgoJPGNpcmNsZSBpZD0iRWxsaXBzZV8yODIiIGNsYXNzPSJzdDAiIGN4PSIxMiIgY3k9IjEyIiByPSIxMS4xIi8+Cgk8cGF0aCBpZD0iUGF0aF81MTMzIiBjbGFzcz0ic3QwIiBkPSJNMTAuMiwxMC4ySDEydjciLz4KCTxsaW5lIGlkPSJMaW5lXzY0NyIgY2xhc3M9InN0MCIgeDE9IjEwLjIiIHkxPSIxNy41IiB4Mj0iMTMuOCIgeTI9IjE3LjUiLz4KCTxwYXRoIGlkPSJQYXRoXzUxMzQiIGNsYXNzPSJzdDEiIGQ9Ik0xMiw2LjVjLTAuMywwLTAuNS0wLjItMC41LTAuNWMwLTAuMywwLjItMC41LDAuNS0wLjVjMCwwLDAsMCwwLDAiLz4KCTxwYXRoIGlkPSJQYXRoXzUxMzUiIGNsYXNzPSJzdDEiIGQ9Ik0xMiw2LjVjMC4zLDAsMC41LTAuMiwwLjUtMC41UzEyLjMsNS41LDEyLDUuNWMwLDAsMCwwLDAsMCIvPgo8L2c+Cjwvc3ZnPgo=";
export { SvgInfo as ReactComponent };